import AccountUtils from '@pinchonation/auth-utils';

const utils = new AccountUtils(
  process.env.NODE_ENV === 'production'
    ? 'https://europe-west1-blupp-dev.cloudfunctions.net/auth-api'
    : 'http://localhost:3002/blupp-dev/us-central1/auth-api',
);

export default utils;
